import { Row, Col } from "react-flexbox-grid";
import ButtonMaterial from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

import styled from "styled-components";

const ButtonFormat = styled(ButtonMaterial)`
  margin: ${({ margin }) => `${margin} !important`};
`;

export const Button = ({
  size = "large",
  className = "",
  maxWidth = "100%",
  htmlType = "button",
  onClick = () => {},
  margin = "0px",
  children,
  color = "primary",
  variant = "contained",
  disabled,
  loading,
  disableElevation,
  id,
}) => {
  return (
    <>
      {loading ? (
        <Row center="xs">
          <Col md={12}>
            <CircularProgress color="secondary" />
          </Col>
        </Row>
      ) : (
        <ButtonFormat
          id={id}
          variant={variant}
          color={color}
          disabled={disabled}
          disableElevation={disableElevation}
          size={size}
          margin={margin}
          type={htmlType}
          className={className}
          style={{ maxWidth }}
          onClick={onClick}
        >
          {children}
        </ButtonFormat>
      )}
    </>
  );
};
